module.exports = __webpack_public_path__ + "assets/img/head.dba98711.png";